import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Navigate, Outlet, useLocation, useSearchParams,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { fetchRefreshToken, selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import APP_CONTEXT from '../../../../../ui-kitchen/src/constants/appContext';
import Loader from '../../../../../ui-kitchen/src/components/Loader';

const AuthenticatedRoute = ({
  isAuthenticated, isAuthLoading,
}) => {
  const loc = useLocation();
  const params = useSearchParams();
  let hasAuthToken = false;
  useEffect(() => {
    const doFetch = async () => {
      hasAuthToken = await fetchRefreshToken(APP_CONTEXT.WIDGET);
    };
    doFetch();
  }, []);

  if (isAuthLoading) {
    return <Loader />;
  }
  if (isAuthenticated || hasAuthToken) {
    return <Outlet />;
  }
  const signup = params.get('signup');
  const redirectTo = signup ? '/signup' : '/login';
  return <Navigate to={`${redirectTo}?next=${loc.pathname}`} />;
};

AuthenticatedRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isAuthLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isAuthLoading: state.authToken.isLoading,
});

export { AuthenticatedRoute as ComponentUnderTest };
export default connect(mapStateToProps)(AuthenticatedRoute);
